// filepath: cryptobag-com/src/utils/formatters.js
/**
 * Formats a number as a USD currency string.
 * Adapts decimal places for very small or large numbers.
 */
export const formatCurrency = (number, fractions = 'auto') => {
  if (number === null || number === undefined) return 'N/A';
  const minFractions = fractions === 'auto' ? 2 : fractions;
  const maxFractions = fractions === 'auto' ? (number < 1 ? 8 : 2) : fractions;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: minFractions,
    maximumFractionDigits: maxFractions,
  }).format(number);
};

/**
 * Formats a large number into a compact, human-readable string (e.g., 1.2B, 3.4M).
 */
export const formatCompactNumber = (number) => {
  if (number === null || number === undefined) return 'N/A';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};